<!-- {@see PChipStyles.vue} -->

<template />

<style lang="postcss">
.p-iconfield {
  @apply relative;

  & .p-inputicon:first-child {
    @apply start-3;
  }

  & .p-inputicon:last-child {
    @apply end-3;
  }

  & .p-inputtext:not(:first-child) {
    @apply ps-10;
  }

  & .p-inputtext:not(:last-child) {
    @apply pe-10;
  }
}

.p-inputicon {
  @apply absolute top-1/2 z-10 -mt-2 leading-none text-surface-400;
}
</style>
